// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-96cb1ac8] .v--modal {
  top: 0 !important;
  left: 0 !important;
  border-radius: unset !important;
}
.viewer[data-v-96cb1ac8] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.viewer[data-v-96cb1ac8]:focus {
  outline: none;
}
.viewer .header[data-v-96cb1ac8] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
}
.viewer .header .user[data-v-96cb1ac8] {
  display: flex;
}
.viewer .header .user .icon-block[data-v-96cb1ac8] {
  margin-right: 10px;
}
.viewer .header .user .user-info[data-v-96cb1ac8] {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.viewer .header .user .user-info .fio[data-v-96cb1ac8] {
  margin-bottom: 4px;
}
.viewer .header .user .user-info .time[data-v-96cb1ac8] {
  font-size: 12px;
}
.viewer .header .btns[data-v-96cb1ac8] {
  color: var(--toolbtn-color);
  display: flex;
  align-items: center;
  margin-left: auto;
}
.viewer .header .btns .pdf-block[data-v-96cb1ac8] {
  display: flex;
  color: var(--toolbtn-color);
  margin-right: 25px;
}
.viewer .header .btns .pdf-block .current-page[data-v-96cb1ac8] {
  width: 40px;
}
.viewer .header .btns .pdf-block .all-pages[data-v-96cb1ac8] {
  width: 50px;
}
.viewer .header .btns .btns-block[data-v-96cb1ac8] {
  color: var(--toolbtn-color);
  margin-right: 25px;
  display: flex;
  align-items: center;
  font-size: 24px;
}
.viewer .header .btns .btns-block .btn-zoom[data-v-96cb1ac8] {
  color: var(--toolbtn-color);
  margin-right: 20px;
  font-weight: 500;
  cursor: pointer;
}
.viewer .header .btns .btns-block .btn-zoom[data-v-96cb1ac8]:hover {
  color: var(--toolbtn-color-hover);
}
.viewer .header .btns .btns-block .btn-turn[data-v-96cb1ac8] {
  color: var(--toolbtn-color);
  font-size: 26px;
  margin-right: 20px;
  font-weight: 500;
  cursor: pointer;
  padding-top: 6px;
  -moz-transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
  -o-transform: rotateX(180deg);
  transform: rotateX(180deg);
}
.viewer .header .btns .btns-block .btn-turn[data-v-96cb1ac8]:hover {
  color: var(--toolbtn-color-hover);
}
.viewer .header .btns .btns-block .download-link[data-v-96cb1ac8] {
  display: flex;
  justify-content: center;
  width: 64px;
}
.viewer .header .btns .btn-print[data-v-96cb1ac8] {
  cursor: pointer;
}
.viewer .header .btns .btn-print[data-v-96cb1ac8]:hover {
  color: var(--toolbtn-color-hover);
}
.viewer .header .btns a[data-v-96cb1ac8] {
  outline: none;
  width: 22px;
}
.viewer .header .btns a .download[data-v-96cb1ac8] {
  color: var(--toolbtn-color);
  font-size: 25px;
  font-weight: 500;
  cursor: pointer;
}
.viewer .header .btns a .download[data-v-96cb1ac8]:hover {
  color: var(--toolbtn-color-hover);
}
.viewer .header .btns .btn-close[data-v-96cb1ac8] {
  font-size: 30px;
  margin-right: 20px;
  cursor: pointer;
}
.viewer .header .btns .btn-close[data-v-96cb1ac8]:hover {
  color: var(--toolbtn-color-hover);
}
.viewer .body[data-v-96cb1ac8] {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  height: 88%;
  padding: 0 20px 20px 20px;
}
.viewer .body .mediaa[data-v-96cb1ac8] {
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
}
.viewer .body .mediaa .pdf[data-v-96cb1ac8] {
  height: 80%;
  width: 600px;
}
.viewer .body .mediaa > video[data-v-96cb1ac8] {
  max-height: 80%;
  object-fit: scale-down;
  overflow: hidden;
}
.viewer .body .mediaa > img[data-v-96cb1ac8] {
  position: absolute;
}
.viewer .body .mediaa .xhr-progress[data-v-96cb1ac8] {
  position: absolute;
}
.viewer .body .mediaa i.fal.fa-spinner[data-v-96cb1ac8] {
  font-size: 30px;
  color: #aaa;
  position: absolute;
}
.viewer .body .mediaa-block[data-v-96cb1ac8] {
  justify-content: center;
  display: flex;
  align-items: center;
}
.viewer .body .slider-block[data-v-96cb1ac8] {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.viewer .body .slider-block img[data-v-96cb1ac8] {
  max-width: 90%;
  max-height: 86%;
  object-fit: contain;
}
.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8],
.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8] {
  color: var(--slide-arrow-color);
  background: var(--slide-arrow-bg);
  font-size: 2em;
  min-width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.5s linear;
  z-index: 1000;
}
.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8]:hover,
.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8]:hover {
  cursor: pointer;
  color: var(--toolbtn-active-color);
}
.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8] {
  padding-right: 0.05em;
  margin-left: 20px;
}
.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8] {
  padding-left: 0.05em;
  margin-right: 20px;
}
.viewer .body .slides-count-box[data-v-96cb1ac8] {
  display: flex;
  flex-direction: column;
  transition: visibility 0.5s, opacity 0.5s linear;
  justify-content: center;
  align-items: center;
  height: 75px;
  min-width: 30px;
  position: absolute;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
}
.viewer .body .slides-count-box .preview-block-wrapper[data-v-96cb1ac8] {
  display: flex;
  flex-direction: row;
  margin-bottom: 6px;
}
.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8] {
  width: 48px;
  height: 48px;
  transition: all 0.1s linear;
}
.viewer .body .slides-count-box .preview-block-wrapper .preview-block img[data-v-96cb1ac8] {
  object-fit: cover;
  height: inherit;
  width: 100%;
}
.viewer .body .slides-count-box .preview-block-wrapper .preview-block.active-slide img[data-v-96cb1ac8] {
  border: 1px solid #00aafb;
}
.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8]:not(:last-child) {
  margin-right: 6px;
}
.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8]:hover {
  transform: scale(1.1);
}
.viewer .body .slides-count-box .slides[data-v-96cb1ac8] {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.viewer .body .slides-count-box .slides .slide[data-v-96cb1ac8] {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #bdbdbd;
}
.viewer .body .slides-count-box .slides .slide[data-v-96cb1ac8]:not(:last-child) {
  margin-right: 2px;
}
.viewer .body .slides-count-box .slides .active-slide[data-v-96cb1ac8] {
  height: 8px;
  width: 8px;
  background: #00aafb;
}
.viewer .body:hover .slides-count-box[data-v-96cb1ac8],
.viewer .body:hover .slide-arrow-back[data-v-96cb1ac8],
.viewer .body:hover .slide-arrow-next[data-v-96cb1ac8] {
  visibility: visible;
  opacity: 1;
}
.activeZoom[data-v-96cb1ac8] {
  height: 88%!important;
  width: 100%;
  margin: 0 auto;
  padding: 0px;
}
.subtitle[data-v-96cb1ac8] {
  position: absolute;
  bottom: 24px;
  padding: 4px 10px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.7);
  max-width: 80%;
  overflow: hidden;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: var(--mediaviewer-caption-bg);
}
.subtitle .scroll[data-v-96cb1ac8] {
  display: block;
  text-align: center;
  z-index: 10;
  color: #181818;
  max-height: 60px;
  margin: 0 auto;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--font-color);
}
.disableBtn[data-v-96cb1ac8] {
  opacity: 0.3;
  color: #757575!important;
}
.photo[data-v-96cb1ac8] {
  object-fit: content;
  height: inherit;
}
/*.footer {
    height: 78px;
    position: relative;
    width: 100%;
    display: block;
}*/
`, "",{"version":3,"sources":["webpack://./js/app/components/mediaViewer/MediaViewer.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+BAA+B;EAC/B,aAAa;AACf;AACA;;EAEE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;;;EAGE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;;EAKE","sourcesContent":["[data-v-96cb1ac8] .v--modal {\n  top: 0 !important;\n  left: 0 !important;\n  border-radius: unset !important;\n}\n.viewer[data-v-96cb1ac8] {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.viewer[data-v-96cb1ac8]:focus {\n  outline: none;\n}\n.viewer .header[data-v-96cb1ac8] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 15px;\n}\n.viewer .header .user[data-v-96cb1ac8] {\n  display: flex;\n}\n.viewer .header .user .icon-block[data-v-96cb1ac8] {\n  margin-right: 10px;\n}\n.viewer .header .user .user-info[data-v-96cb1ac8] {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.viewer .header .user .user-info .fio[data-v-96cb1ac8] {\n  margin-bottom: 4px;\n}\n.viewer .header .user .user-info .time[data-v-96cb1ac8] {\n  font-size: 12px;\n}\n.viewer .header .btns[data-v-96cb1ac8] {\n  color: var(--toolbtn-color);\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n.viewer .header .btns .pdf-block[data-v-96cb1ac8] {\n  display: flex;\n  color: var(--toolbtn-color);\n  margin-right: 25px;\n}\n.viewer .header .btns .pdf-block .current-page[data-v-96cb1ac8] {\n  width: 40px;\n}\n.viewer .header .btns .pdf-block .all-pages[data-v-96cb1ac8] {\n  width: 50px;\n}\n.viewer .header .btns .btns-block[data-v-96cb1ac8] {\n  color: var(--toolbtn-color);\n  margin-right: 25px;\n  display: flex;\n  align-items: center;\n  font-size: 24px;\n}\n.viewer .header .btns .btns-block .btn-zoom[data-v-96cb1ac8] {\n  color: var(--toolbtn-color);\n  margin-right: 20px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.viewer .header .btns .btns-block .btn-zoom[data-v-96cb1ac8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.viewer .header .btns .btns-block .btn-turn[data-v-96cb1ac8] {\n  color: var(--toolbtn-color);\n  font-size: 26px;\n  margin-right: 20px;\n  font-weight: 500;\n  cursor: pointer;\n  padding-top: 6px;\n  -moz-transform: rotateX(180deg);\n  -ms-transform: rotateX(180deg);\n  -webkit-transform: rotateX(180deg);\n  -o-transform: rotateX(180deg);\n  transform: rotateX(180deg);\n}\n.viewer .header .btns .btns-block .btn-turn[data-v-96cb1ac8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.viewer .header .btns .btns-block .download-link[data-v-96cb1ac8] {\n  display: flex;\n  justify-content: center;\n  width: 64px;\n}\n.viewer .header .btns .btn-print[data-v-96cb1ac8] {\n  cursor: pointer;\n}\n.viewer .header .btns .btn-print[data-v-96cb1ac8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.viewer .header .btns a[data-v-96cb1ac8] {\n  outline: none;\n  width: 22px;\n}\n.viewer .header .btns a .download[data-v-96cb1ac8] {\n  color: var(--toolbtn-color);\n  font-size: 25px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.viewer .header .btns a .download[data-v-96cb1ac8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.viewer .header .btns .btn-close[data-v-96cb1ac8] {\n  font-size: 30px;\n  margin-right: 20px;\n  cursor: pointer;\n}\n.viewer .header .btns .btn-close[data-v-96cb1ac8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.viewer .body[data-v-96cb1ac8] {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1;\n  height: 88%;\n  padding: 0 20px 20px 20px;\n}\n.viewer .body .mediaa[data-v-96cb1ac8] {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.viewer .body .mediaa .pdf[data-v-96cb1ac8] {\n  height: 80%;\n  width: 600px;\n}\n.viewer .body .mediaa > video[data-v-96cb1ac8] {\n  max-height: 80%;\n  object-fit: scale-down;\n  overflow: hidden;\n}\n.viewer .body .mediaa > img[data-v-96cb1ac8] {\n  position: absolute;\n}\n.viewer .body .mediaa .xhr-progress[data-v-96cb1ac8] {\n  position: absolute;\n}\n.viewer .body .mediaa i.fal.fa-spinner[data-v-96cb1ac8] {\n  font-size: 30px;\n  color: #aaa;\n  position: absolute;\n}\n.viewer .body .mediaa-block[data-v-96cb1ac8] {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n.viewer .body .slider-block[data-v-96cb1ac8] {\n  display: flex;\n  flex: 1 1;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n}\n.viewer .body .slider-block img[data-v-96cb1ac8] {\n  max-width: 90%;\n  max-height: 86%;\n  object-fit: contain;\n}\n.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8],\n.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8] {\n  color: var(--slide-arrow-color);\n  background: var(--slide-arrow-bg);\n  font-size: 2em;\n  min-width: 1.5em;\n  height: 1.5em;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.5s linear;\n  z-index: 1000;\n}\n.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8]:hover,\n.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8]:hover {\n  cursor: pointer;\n  color: var(--toolbtn-active-color);\n}\n.viewer .body .slider-block .slide-arrow-back[data-v-96cb1ac8] {\n  padding-right: 0.05em;\n  margin-left: 20px;\n}\n.viewer .body .slider-block .slide-arrow-next[data-v-96cb1ac8] {\n  padding-left: 0.05em;\n  margin-right: 20px;\n}\n.viewer .body .slides-count-box[data-v-96cb1ac8] {\n  display: flex;\n  flex-direction: column;\n  transition: visibility 0.5s, opacity 0.5s linear;\n  justify-content: center;\n  align-items: center;\n  height: 75px;\n  min-width: 30px;\n  position: absolute;\n  z-index: 1000;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.viewer .body .slides-count-box .preview-block-wrapper[data-v-96cb1ac8] {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 6px;\n}\n.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8] {\n  width: 48px;\n  height: 48px;\n  transition: all 0.1s linear;\n}\n.viewer .body .slides-count-box .preview-block-wrapper .preview-block img[data-v-96cb1ac8] {\n  object-fit: cover;\n  height: inherit;\n  width: 100%;\n}\n.viewer .body .slides-count-box .preview-block-wrapper .preview-block.active-slide img[data-v-96cb1ac8] {\n  border: 1px solid #00aafb;\n}\n.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8]:not(:last-child) {\n  margin-right: 6px;\n}\n.viewer .body .slides-count-box .preview-block-wrapper .preview-block[data-v-96cb1ac8]:hover {\n  transform: scale(1.1);\n}\n.viewer .body .slides-count-box .slides[data-v-96cb1ac8] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.viewer .body .slides-count-box .slides .slide[data-v-96cb1ac8] {\n  height: 6px;\n  width: 6px;\n  border-radius: 50%;\n  background: #bdbdbd;\n}\n.viewer .body .slides-count-box .slides .slide[data-v-96cb1ac8]:not(:last-child) {\n  margin-right: 2px;\n}\n.viewer .body .slides-count-box .slides .active-slide[data-v-96cb1ac8] {\n  height: 8px;\n  width: 8px;\n  background: #00aafb;\n}\n.viewer .body:hover .slides-count-box[data-v-96cb1ac8],\n.viewer .body:hover .slide-arrow-back[data-v-96cb1ac8],\n.viewer .body:hover .slide-arrow-next[data-v-96cb1ac8] {\n  visibility: visible;\n  opacity: 1;\n}\n.activeZoom[data-v-96cb1ac8] {\n  height: 88%!important;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0px;\n}\n.subtitle[data-v-96cb1ac8] {\n  position: absolute;\n  bottom: 24px;\n  padding: 4px 10px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.7);\n  max-width: 80%;\n  overflow: hidden;\n  left: 50%;\n  transform: translate(-50%, 0);\n  background-color: var(--mediaviewer-caption-bg);\n}\n.subtitle .scroll[data-v-96cb1ac8] {\n  display: block;\n  text-align: center;\n  z-index: 10;\n  color: #181818;\n  max-height: 60px;\n  margin: 0 auto;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--font-color);\n}\n.disableBtn[data-v-96cb1ac8] {\n  opacity: 0.3;\n  color: #757575!important;\n}\n.photo[data-v-96cb1ac8] {\n  object-fit: content;\n  height: inherit;\n}\n/*.footer {\n    height: 78px;\n    position: relative;\n    width: 100%;\n    display: block;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
